<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <b-form @submit="onSubmit" @reset="onReset" novalidate="novalidate">
          <div class="card">
            <div class="card-header card-header-icon card-header-rose">
              <div class="card-icon" v-b-toggle.filter>
                <i class="material-icons">search</i>
              </div>
              <h4 class="card-title">Filtros</h4>
            </div>
            <br />
            <b-collapse id="filter">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-2">
                    <div class="form-group bmd-form-group is-filled">
                      <label for="interval" class="bmd-label-floating">Data de referência</label>
                      <model-list-select
                        class="form-control"
                        :list="[
                          { id: 'sale_date', name: 'Data da venda' },
                          { id: 'payment_date', name: 'Data de pagamento' },
                        ]"
                        option-value="id"
                        option-text="name"
                        v-model="filters.reference_date"
                      ></model-list-select>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group bmd-form-group is-filled">
                      <label for="interval" class="bmd-label-floating" v-if="filters.reference_date === 'sale_date'">Intervalo Data de venda</label>
                      <label for="interval" class="bmd-label-floating" v-if="filters.reference_date === 'payment_date'">Intervalo Data de pagamento</label>
                      <date-picker
                        range
                        v-model="filters.interval"
                        lang="pt-br"
                        format="DD/MM/YYYY"
                        placeholder="Escolha uma data"
                        :not-after="filters.end_at"
                      ></date-picker>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group bmd-form-group is-filled">
                      <label for="interval" class="bmd-label-floating">Data de próx. contato</label>
                      <date-picker
                        v-model="filters.next_contact_at"
                        lang="pt-br"
                        format="DD/MM/YYYY"
                        placeholder="Escolha uma data"
                      ></date-picker>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group bmd-form-group is-filled">
                      <label for="interval" class="bmd-label-floating">Intervalo Data de vencimento</label>
                      <date-picker
                        range
                        v-model="filters.due_at"
                        lang="pt-br"
                        format="DD/MM/YYYY"
                        placeholder="Escolha uma data"
                      ></date-picker>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group bmd-form-group is-filled">
                      <label for="proposal_status" class="bmd-label-floating">Status da parcela</label>
                      <model-list-select
                        class="form-control"
                        :list="[
                          { id: 'installment_paid', name: 'Parcelas pagas' },
                          { id: 'not_paid', name: 'Não pagas' },
                          { id: 'both', name: 'Ambos' },
                        ]"
                        option-value="id"
                        option-text="name"
                        v-model="filters.status"
                      ></model-list-select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group bmd-form-group is-filled">
                      <label for="administrator_id" class="bmd-label-floating">Administradora</label>
                      <model-list-select
                        class="form-control"
                        :list="administrators"
                        option-value="id"
                        option-text="name"
                        v-model="filters.administrator_id"
                        @input="loadGroups"
                      ></model-list-select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group bmd-form-group is-filled">
                      <label for="group_id" class="bmd-label-floating">Grupo</label>
                      <model-list-select
                        class="form-control"
                        :list="groups"
                        option-value="id"
                        option-text="name"
                        v-model="filters.group_id"
                      ></model-list-select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group bmd-form-group" :class="{'is-filled': filters.client_name != ''}">
                      <label form="client_name" class="bmd-label-floating">Nome do cliente / Parte do nome</label>
                      <input
                        refs="client_name"
                        type="text"
                        maxlength="64"
                        class="form-control"
                        v-model="filters.client_name"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    
                    <div
                      class="form-group bmd-form-group"
                      v-bind:class="{'is-filled': filters.physical_proposal != ''}"
                    >
                      <label form="physical_proposal" class="bmd-label-floating">Contrato</label>
                      <input
                        refs="physical_proposal"
                        type="text"
                        maxlength="20"
                        v-numeric-only
                        class="form-control"
                        v-model="filters.physical_proposal"
                      />
                    </div>
                    
                  </div>
                  <div class="col-md-4">
                    <div
                      class="form-group bmd-form-group"
                      v-bind:class="{'is-filled': filters.installment != ''}"
                    >
                      <label form="installment" class="bmd-label-floating">Parcela</label>
                      <input
                        refs="installment"
                        type="text"
                        maxlength="20"
                        v-numeric-only
                        class="form-control"
                        v-model="filters.installment"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <button type="reset" class="btn btn-fill btn-outline-danger">Limpar</button>
                <button type="submit" class="btn btn-fill btn-rose">Filtrar</button>
              </div>
            </b-collapse>
          </div>
        </b-form>
      </div>
    </div>

    <br />
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-icon card-header-rose">
            <div class="card-icon">
              <i class="material-icons">list</i>
            </div>
            <h4 class="card-title">Lista</h4>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Cliente</th>
                    <th>Telefone</th>
                    <th>Bem</th>
                    <th>Vencimento</th>
                    <th>Valor da parcela</th>
                    <th>Parcela</th>
                    <th>Próx. contato</th>
                    <th class="text-right">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-show="charges.length > 0"
                    v-for="(iterator, index) in charges"
                    :key="index"
                  >
                    <td>{{ iterator.proposal.client.name }}</td>
                    <td>{{ iterator.proposal.client.cell_phone | phone }}</td>
                    <td>{{ iterator.proposal.model.manufacturer.name }} - {{ iterator.proposal.model.name }}</td>
                    <td>{{ iterator.due_at | moment('DD/MM/YYYY') }}</td>
                    <td>{{ iterator.price | price }}</td>
                    <td>{{ iterator.order }}/{{ iterator.proposal.number_installments }}</td>
                    <td>
                      <template
                        v-if="iterator.next_contact_at"
                      >{{ iterator.next_contact_at | moment('DD/MM/YYYY HH:mm:ss') }}</template>
                      <template v-else>-</template>
                    </td>
                    <td class="td-actions text-right">
                      <b-button-group>
                        <router-link
                          data-original-title
                          title="Informações da proposta"
                          class="btn btn-outline-primary btn-link"
                          tag="button"
                          :to="{
                            name: 'charges.show', 
                            params: {
                              id: iterator.id,
                              proposal_id: iterator.proposal_id
                            }, 
                            query: $route.query
                          }"
                        >
                          <i class="fa fa-eye"></i>
                        </router-link>
                      </b-button-group>
                      <b-button-group>
                        <router-link
                          data-original-title
                          title="Adicionar próximo contato"
                          class="btn btn-outline-primary btn-link"
                          tag="button"
                          :to="{
                            name: 'charges.contacts.index', 
                            params: {
                              id: iterator.id,
                              proposal_id: iterator.proposal_id
                            }, 
                            query: $route.query
                          }"
                        >
                          <i class="fa fa-phone"></i>
                        </router-link>
                      </b-button-group>

                      <b-button-group>
                        <router-link
                          data-original-title
                          title="Enviar boleto"
                          class="btn btn-outline-primary btn-link"
                          tag="button"
                          :to="{
                            name: 'charges.send_slips.index', 
                            params: {
                              id: iterator.id,
                              proposal_id: iterator.proposal_id
                            },
                            query: $route.query
                          }"
                        >
                          <i class="fa fa-file-pdf"></i>
                        </router-link>
                      </b-button-group>

                      <b-button-group v-if="!iterator.evaluated">
                        <router-link
                          data-original-title
                          title="Avaliar vendedor"
                          class="btn btn-outline-primary btn-link"
                          tag="button"
                          :to="{
                            name: 'charges.salesman_evaluations.index', 
                            params: {
                              id: iterator.id,
                              proposal_id: iterator.proposal_id
                            },
                            query: $route.query
                          }"
                        >
                          <i class="fa fa-thumbs-up"></i>
                        </router-link>
                      </b-button-group>
                    </td>
                  </tr>
                  <tr v-show="charges.length ==   0">
                    <td colspan="10">Nenhuma proposta encontrada!</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card-footer" v-show="charges.length >= 10 || pagination.page != 1">  
            <b-pagination
              order="is-right"
              v-show="charges.length > 0"
              v-model="pagination.page"
              :simple="false"
              :per-page="pagination.limit"
              :total-rows="pagination.total"
              @change="pageChange"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      ref="modal"
      dialog-class="modal-lg"
      hide-footer
      scrollable
      :visible="$route.meta.showModal"
      :title="$route.meta.title"
      @hide="hideModal"
    >
      <router-view name="modal" />
    </b-modal>
  </div>
</template>
<script>
import Vue from "vue";
import JwtService from "@/services/jwt.service";
import GroupService from "@/services/modules/groups.service";
import ProposalService from "@/services/modules/charges.service";
import UserService from "@/services/modules/users.service";
import _ from "lodash";
import table_report from "@/mixins/table_report";
export default {
  mixins: [table_report],
  computed: {
    administrators: {
      set(_administrators) {},
      get() {
        const ar = Array.from(this.$store.state.administrators.itens);
        ar.unshift({
          id: "-1",
          name: "Todas"
        });
        return ar;
      }
    },
    charges: {
      set(_charges) {},
      get() {
        return this.$store.state.charges.itens
          ? this.$store.state.charges.itens.data
          : [];
      }
    }
  },
  beforeDestroy() {
    this.$root.$off("hideModal");
    this.$root.$off("updateList");
  },
  created() {
    this.$root.$on("hideModal", () => {
      this.$refs.modal.hide();
    });
    this.$root.$on("updateList", () => {
      this.getItems();
    });
    this.getDataAdministrators();
  },
  mounted() {
    this.onReset(this.$event);
    window.setTimeout(_ => this.onSubmit(this.$event), 500);
  },
  watch: {
    "filters.interval"(v) {
      if (v != null) {
        this.filters.init_at = "";
        this.filters.end_at = "";
        if (v[0]) {
          this.filters.init_at = Vue.moment(v[0]).format("YYYY-MM-DD");
        } else {
          this.filters.init_at = "";
        }

        if (v[1]) {
          this.filters.end_at = Vue.moment(v[1]).format("YYYY-MM-DD");
        } else {
          this.filters.end_at = "";
        }
      }
    },
    "filters.due_at"(v) {
      if (v != null) {
        this.filters.due_init_at = "";
        this.filters.due_end_at = "";
        if (v[0]) {
          this.filters.due_init_at = Vue.moment(v[0]).format("YYYY-MM-DD");
        } else {
          this.filters.due_init_at = "";
        }

        if (v[1]) {
          this.filters.due_end_at = Vue.moment(v[1]).format("YYYY-MM-DD");
        } else {
          this.filters.due_end_at = "";
        }
      }
    }
  },
  data() {
    return {
      filters: {
        reference_date: "sale_date",
        installment: "",
        client_name : "",
        physical_proposal : "",
        branch_id: "",
        interval: this.$route.query.init_at
          ? [
              Vue.moment(this.$route.query.init_at),
              Vue.moment(this.$route.query.end_at)
            ]
          : [Vue.moment().subtract(30, "days"), Vue.moment()],
        due_at: this.$route.query.due_init_at
          ? [
              Vue.moment(this.$route.query.due_init_at),
              Vue.moment(this.$route.query.due_end_at)
            ]
          : [null, null],
        status: "both",
        administrator_id: "",
        group_id: "",
        due_init_at: "",
        due_end_at: "",
        init_at: "",
        end_at: "",
        next_contact_at: ""
      },
      pagination: {
        limit: this.$route.query.limit ? parseInt(this.$route.query.limit) : 15,
        page: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
        total: this.$route.query.total ? parseInt(this.$route.query.total) : 0
      },
      groups: [],
      hideFilter: false,
      listProposals: []
    };
  },
  methods: {
    hideModal() {
      this.$router.go(-1);
    },
    async getItems() {
      this.$root.$emit("onLoading");

      this.filters.branch_id = this.$store.state.auth.user.branch_id;

      const response = this.$store.dispatch("charges/all", {
        limit: this.pagination.limit,
        page: this.pagination.page,
        params: this.filters
      });

      response.then(_pagination => {
        this.pagination.total = _pagination.data.total
          ? _pagination.data.total
          : 0;
        this.$root.$emit("onLoading");

        const filters = _.cloneDeep({ ...this.filters, ...this.pagination });
        delete filters["interval"];
        this.updateQueryStrings(filters);
      });

      response.catch(() => {
        this.$root.$emit("onLoading");
        this.$notify.error("Falha na comunicação com a API!");
      });
    },
    async getDataAdministrators() {
      this.$root.$emit("onLoading");

      const response = this.$store.dispatch("administrators/all");

      response.then(() => {
        this.boot();
        this.$root.$emit("onLoading");
      });

      response.catch(() => {
        this.getItems();
        this.$root.$emit("onLoading");
      });
    },
    async getDataGroups(_administratorId) {
      this.$root.$emit("onLoading");

      const response = GroupService.getByAdministratorId(_administratorId);

      response.then(_groups => {
        _groups.unshift({
          id: "-1",
          name: "Todas"
        });
        this.groups = _groups;
        this.$root.$emit("onLoading");
      });

      response.catch(() => {
        this.$root.$emit("onLoading");
      });
    },
    hideFilters() {
      var self = this;

      self.hideFilter = !self.hideFilter;
    },
    loadGroups() {
      if (this.filters.administrator_id != "") {
        this.getDataGroups(this.filters.administrator_id);
      }
    },
    pageChange(_pageNum) {
      this.pagination.page = _pageNum;
      this.getItems();
    },
    onReset(_ev=null) {
      if(_ev)
        _ev.preventDefault();

      this.filters = {
        reference_date: "sale_date",
        installment: "",
        branch_id: "",
        physical_proposal : "",
        client_name : "",
        interval: this.$route.query.init_at
          ? [
              Vue.moment(this.$route.query.init_at),
              Vue.moment(this.$route.query.end_at)
            ]
          : [Vue.moment().subtract(30, "days"), Vue.moment()],
        status: "both",
        administrator_id: "",
        group_id: "",
        init_at: "",
        end_at: ""
      };

      this.pagination.page = 1;

      this.getItems();
    },
    onSubmit(_ev=null) {
      if(_ev)
        _ev.preventDefault();

      this.pagination.page = 1;

      this.getItems();
    }
  }
};
</script>

<style scoped>
.mx-datepicker {
  width: 100%;
}
</style>